// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDD1TxfmjtsrRqQR9O9TJIqoZncktiWGWw",
  authDomain: "to-do-app-382c5.firebaseapp.com",
  projectId: "to-do-app-382c5",
  storageBucket: "to-do-app-382c5.appspot.com",
  messagingSenderId: "1017638745006",
  appId: "1:1017638745006:web:daea8763403d2cbe858e3f",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth();
